import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { ArrowRight, Sparkles } from 'lucide-react';

const MegaIndustries = ({ industries, onEnter, onLeave }) => (
  <div
    data-testid="mega-industries"
    onMouseEnter={onEnter}
    onMouseLeave={onLeave}
    className="hidden lg:block absolute left-0 right-0 top-full bg-gradient-to-b from-white via-gray-50 to-gray-100 border-y border-gray-200 shadow-2xl shadow-gray-400/30 animate-fadeIn"
  >
    <div className="max-w-[1400px] mx-auto px-6 py-8">
      <div className="flex items-center justify-between mb-5">
        <div>
          <div className="text-orange-500 text-[10px] uppercase tracking-[0.25em] font-bold mb-1">Verticals</div>
          <h3 className="text-[#0e1116] text-2xl font-black">Industries <span className="text-green-600">We Serve</span></h3>
        </div>
        <Link to="/industries" className="hidden md:inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider text-gray-600 hover:text-green-600" data-testid="mega-industries-explore">
          Explore all industries <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-x-5 gap-y-5 normal-case">
        {industries.map(ind => {
          const Ic = Icons[ind.icon] || Icons.Briefcase;
          return (
            <Link
              key={ind.slug}
              to={`/industries/${ind.slug}`}
              data-testid={`mega-ind-${ind.slug}`}
              className="group bg-white hover:bg-gray-50 border border-gray-200 hover:border-orange-400/60 rounded-lg p-4 transition-all shadow-sm hover:shadow-md"
            >
              <div className="flex items-center gap-2 text-[#0e1116] font-bold text-[13px] group-hover:text-green-600">
                <Ic className="w-4 h-4 text-orange-500" /> {ind.title}
              </div>
              <p className="text-[11px] text-gray-500 mt-2 leading-snug line-clamp-3">{ind.desc}</p>
              <span className="mt-2 inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-green-600 group-hover:text-orange-500">
                Know more <ArrowRight className="w-2.5 h-2.5" />
              </span>
            </Link>
          );
        })}
      </div>
      <div className="pt-5 mt-6 border-t border-gray-200 flex items-center justify-between text-xs text-gray-500">
        <span className="flex items-center gap-2"><Sparkles className="w-3.5 h-3.5 text-orange-500" /> {industries.length} verticals — engineered with domain depth</span>
        <Link to="/contact" className="text-orange-500 hover:text-orange-600 font-bold uppercase tracking-wider">Talk to an expert →</Link>
      </div>
    </div>
  </div>
);

export default MegaIndustries;
